import { initializeApp } from 'firebase/app';
import {
  GoogleAuthProvider,
  browserLocalPersistence,
  getAuth,
  setPersistence,
  signInWithPopup,
  signOut,
  type Auth,
} from 'firebase/auth';
import { getDatabase, type Database } from 'firebase/database';

function required(name: string, value: string | undefined): string {
  if (value === undefined || value.length === 0) {
    throw new Error(`Falta ${name} en el .env de la raíz del repo (copia .env.example)`);
  }
  return value;
}

export interface FirebaseHandles {
  auth: Auth;
  db: Database;
}

export async function initFirebase(): Promise<FirebaseHandles> {
  const app = initializeApp({
    apiKey: required('VITE_FIREBASE_API_KEY', import.meta.env.VITE_FIREBASE_API_KEY),
    authDomain: required('VITE_FIREBASE_AUTH_DOMAIN', import.meta.env.VITE_FIREBASE_AUTH_DOMAIN),
    projectId: required('VITE_FIREBASE_PROJECT_ID', import.meta.env.VITE_FIREBASE_PROJECT_ID),
    databaseURL: required('VITE_FIREBASE_DATABASE_URL', import.meta.env.VITE_FIREBASE_DATABASE_URL),
    appId: required('VITE_FIREBASE_APP_ID', import.meta.env.VITE_FIREBASE_APP_ID),
  });

  const auth = getAuth(app);
  await setPersistence(auth, browserLocalPersistence);

  return { auth, db: getDatabase(app) };
}

/** En el navegador sí se puede usar el popup: aquí no hay embedded user agent. */
export async function signInWithGoogle(auth: Auth): Promise<void> {
  const provider = new GoogleAuthProvider();
  provider.setCustomParameters({ prompt: 'select_account' });
  await signInWithPopup(auth, provider);
}

export async function signOutOfGoogle(auth: Auth): Promise<void> {
  await signOut(auth);
}
